import React from 'react';
import { PageHero, Card } from '../components/ui';

export default function CookiePolicy() {
    const lastUpdated = "July 29, 2025";

    return (
        <div className="bg-slate-50 dark:bg-slate-900 min-h-screen transition-colors duration-200">
            <PageHero
                title="Cookie Policy"
                subtitle={`Last updated: ${lastUpdated}`}
            />

            <main className="container mx-auto px-4 -mt-16 relative z-10 pb-16 max-w-4xl">
                <Card>
                    <div className="space-y-8 text-slate-700 dark:text-slate-300 leading-relaxed text-base">
                        <p>
                            This Cookie Policy explains how Gift Scout LLC uses cookies and similar tracking technologies on our website, https://giftscout.net (the "Site").
                        </p>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">1. What Are Cookies?</h2>
                        <p>
                            Cookies are small data files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide analytics and personalized experiences.
                        </p>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">2. How We Use Cookies</h2>
                        <p>We use cookies for the following purposes:</p>
                        <ul className="list-disc list-inside space-y-2 pl-4">
                            <li><strong>Essential cookies:</strong> Required to enable core site functionality, like user authentication and session handling.</li>
                            <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with the site (e.g., Google Analytics or Plausible).</li>
                            <li><strong>Advertising cookies:</strong> Used to display personalized ads and track ad performance (e.g., Google AdSense or affiliate tracking pixels).</li>
                        </ul>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">3. Managing Cookies</h2>
                        <p>
                            You can manage your cookie preferences through your browser settings. Most browsers allow you to refuse or delete cookies. Disabling cookies may affect certain features of the Site.
                        </p>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">4. Third-Party Cookies</h2>
                        <p>
                            Some cookies on our site are placed by third parties, such as advertising networks and analytics providers. These third parties may use cookies to build a profile of your interests and serve relevant advertisements on other websites.
                        </p>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">5. Updates to This Policy</h2>
                        <p>
                            We may update this Cookie Policy from time to time. The latest version will always be available on this page.
                        </p>

                        <h2 className="text-2xl font-bold pt-4 border-b border-slate-200 dark:border-slate-700 pb-2 text-slate-800 dark:text-white">6. Contact</h2>
                        <p>
                            If you have any questions about our use of cookies, please visit our <a href="/contact" className="text-brand-600 dark:text-brand-400 hover:underline font-medium">Contact Page</a>.
                        </p>
                    </div>
                </Card>
            </main>
        </div>
    );
}
